/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

/* Component Imports */

import { Paper, Typography } from "@material-ui/core";
import EMILoanAmount from "./sub-component/EMILoanAmount";
import EMITenure from "./sub-component/EMITenure";
import EMIInterest from "./sub-component/EMIInterest";
import EMIResults from "./sub-component/EMIResults";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "1.5rem",
    marginBottom: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  heading: {
    color: "#202020",
    fontWeight: "400",
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    marginBottom: "1rem",
  },
  disclaimer: {
    color: "#666666",
    fontWeight: "400",
    fontSize: "0.75rem",
    lineHeight: "1rem",
    marginTop: "0.5rem",
  },
}));

const EMICalculator = (props) => {
  const classes = useStyles();

  const [loanAmount, setLoanAmount] = React.useState(props.defaultLoanAmount);
  const [tenure, setTenure] = React.useState(10);
  const [interestRate, setInterestRate] = React.useState(6.5);
  const [totalInterest, setTotalInterest] = React.useState(undefined);
  const [monthlyEMI, setMonthlyEMI] = React.useState(undefined);

  React.useEffect(() => {
    const tenureMonths = tenure * 12;
    const monthlyInterest = interestRate / 1200;
    const top = Math.pow(1 + monthlyInterest, tenureMonths);
    const bottom = top - 1;
    const ratio = top / bottom;
    const EMI = loanAmount * monthlyInterest * ratio;
    const totalEMI = tenureMonths * EMI;
    const totalInterestPayable = totalEMI - loanAmount;

    setMonthlyEMI(
      EMI.toFixed(0).replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ","),
    );
    setTotalInterest(
      totalInterestPayable
        .toFixed(0)
        .replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ","),
    );
  }, [loanAmount, tenure, interestRate]);

  /* Loan Amount Functions */
  const handleChangeLoanAmoutSlider = (event, value) => {
    setLoanAmount(value);
  };
  const handleChangeLoanAmoutTextField = (event) => {
    setLoanAmount(event.target.value);
  };

  /* Tenure Functions */
  const handleChangeTenureSlider = (event, value) => {
    setTenure(value);
  };
  const handleChangeTenureTextField = (event) => {
    setTenure(event.target.value);
  };

  /* Interest Functions */
  const handleChangeInterestRateSlider = (event, value) => {
    setInterestRate(value);
  };
  const handleChangeInterestRateTextField = (event) => {
    setInterestRate(event.target.value);
  };

  if (!props.loading) {
    return (
      <React.Fragment>
        <Paper elevation={2} className={classes.paper}>
          <Typography variant="body2" component="p" className={classes.heading}>
            EMI Calculator
          </Typography>
          <EMILoanAmount
            onChangeLoanAmoutSlider={handleChangeLoanAmoutSlider}
            onChangeLoanAmoutTextField={handleChangeLoanAmoutTextField}
            value={loanAmount}
          />
          <EMITenure
            onChangeTenureSlider={handleChangeTenureSlider}
            onChangeTenureTextField={handleChangeTenureTextField}
            value={tenure}
          />
          <EMIInterest
            onChangeInterestSlider={handleChangeInterestRateSlider}
            onChangeInterestTextField={handleChangeInterestRateTextField}
            value={interestRate}
          />
          <EMIResults
            emi={monthlyEMI}
            tenure={tenure}
            interestRate={interestRate}
            totalInterest={totalInterest}
          />
          <Typography
            variant="body2"
            component="p"
            className={classes.disclaimer}
          >
            *Banks may charge additional processing fees.
          </Typography>
          {/* <Typography
          variant="body2"
          component="p"
          className={classes.disclaimer}
        >
          *This calculator is only for illustrative purposes. These figures may
          or may not be applicable to your particular situation. Lighter Advisory will not
          be responsible for any loss or liability arising from the use of this
          calculator.
        </Typography> */}
        </Paper>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Paper elevation={2} className={classes.paper}>
          <Skeleton>
            <Typography
              variant="body2"
              component="p"
              className={classes.heading}
            >
              EMI Calculator
            </Typography>
          </Skeleton>
          <EMILoanAmount
            onChangeLoanAmoutSlider={handleChangeLoanAmoutSlider}
            onChangeLoanAmoutTextField={handleChangeLoanAmoutTextField}
            value={loanAmount}
          />
          <EMITenure
            onChangeTenureSlider={handleChangeTenureSlider}
            onChangeTenureTextField={handleChangeTenureTextField}
            value={tenure}
          />
          <EMIInterest
            onChangeInterestSlider={handleChangeInterestRateSlider}
            onChangeInterestTextField={handleChangeInterestRateTextField}
            value={interestRate}
          />
          <EMIResults
            emi={monthlyEMI}
            tenure={tenure}
            interestRate={interestRate}
            totalInterest={totalInterest}
          />
          <Skeleton>
            <Typography
              variant="body2"
              component="p"
              className={classes.disclaimer}
            >
              *Banks may charge additional processing fees.
            </Typography>
          </Skeleton>
          {/* <Typography
          variant="body2"
          component="p"
          className={classes.disclaimer}
        >
          *This calculator is only for illustrative purposes. These figures may
          or may not be applicable to your particular situation. Lighter Advisory will not
          be responsible for any loss or liability arising from the use of this
          calculator.
        </Typography> */}
        </Paper>
      </React.Fragment>
    );
  }
};

export default EMICalculator;
